import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const fetchLeads = (token) =>
  api.get("/leads", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const fetchStats = (token) =>
  api.get("/leads/stats", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const verifyAdmin = (token) =>
  api.post("/admin/verify", null, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
